<template>
  <div>
    <select
      class="custom-select"
      style="
        padding: 0.5rem;
        background: #ffff;
        border: 1px solid #ccc;
      "
      :disabled="loading"
    >
      <option @click="onChange" v-for="(item, index) in options" :key="index" :value="item.value">
        {{ item.label }}
      </option>
    </select>

  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";
import axiosAgsc from "@/store/axiosAgsc";
import moment from "moment";

export default {

  props: {
    group: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      policyDates: [],
      search: "",
      loading: false,
    };
  },
  watch: {
    async group() {
      if (this.group) await this.getPolicyDates();
      else this.value = null;
    },
  },
  computed: {
    options() {
      let mapped = this.policyDates.map((f) => {
        let formatted = moment(f.policyDownloadDate).format("YYYY-MM-DD HH:mm")
        return {
          label: `From V.${f.policyVersion} ${formatted}`,
          value: f.policyDownloadDate,
        };
      });
      return mapped
    },
  },
  methods: {
    async getPolicyDates() {
      const guid = [this.group];
      const res = await axiosAgsc.post(`/Event/GetLastPolicyDownloadDates`, guid);
      this.policyDates = res.data.entityData;
    },
    onChange(value) {
      this.$emit("change", value);
    },
    async created() {
      let role = (
        this.$store.state.auth.user.find((f) => f.type == "role") || {}
      ).value;
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        role = Roles.AGMSAdmin;
      }
      if (role == Roles.GroupAdmin) {
        const groupGuid = (
          this.$store.state.auth.user.find((f) => f.type == "GroupGuid") || {}
        ).value;
        const guid = JSON.parse(groupGuid)[0];
        const res = await axiosAgsc.post(`/Event/GetLastPolicyDownloadDates`, guid);
        this.policyDates = res.data.entityData;
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped></style>
